import * as React from "react";
import {WordFetcher} from "../WordFetcher";

interface IProps {
    character: string,
    knownCharacters: string,
}

interface IState {}

export class DiacriticNote extends React.Component<IProps, IState> {
    public render() {
        if(WordFetcher.katakanaDiacriticsMapping().has(this.props.character)) {
            let diacriticDescripiton: string;
            let diacriticName: string;
            let diacriticSentence: string;
            if(WordFetcher.katakanaDakutenMapping.has(this.props.character)) {
                if(this.props.knownCharacters.split('').some( char => {
                    return char !== this.props.character && WordFetcher.katakanaDakutenMapping.has(char)
                })) {
                    return "";
                }
                diacriticName = 'Dakuten';
                diacriticDescripiton = "two little dashes";
                diacriticSentence = '<i>k</i>s become <i>g</i>s; <i>s</i>s become <i>z</i>s; <i>t</i>s become <i>d</i>s and <i>g</i>s become <i>b</i>s'
            } else {
                if(this.props.knownCharacters.split('').some( char => {
                    return char !== this.props.character && WordFetcher.katakanaHandakutenMapping.has(char)
                })) {
                    return "";
                }
                diacriticName = 'Handakuten';
                diacriticDescripiton = "little circle";
                diacriticSentence = 'All sounds with an <i>h</i> in it, have that <i>h</i> replaced with a <i>p</i>'
            }
            let baseCharacter = WordFetcher.katakanaDakutenMapping.get(this.props.character);
            return (<div className="diacriticNote">
                <p>This is the first time you encounter a {diacriticName}. The {diacriticName} is the {diacriticDescripiton} at the top right of the character.</p>
                <p>The {diacriticName} modifies the {baseCharacter} character that you are already familiar with. You will encounter the {diacriticName} on more characters going forward.</p>
                <p>{diacriticSentence}</p>
            </div>)
        } else {
            return "";
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/DiacriticNote.tsx